import { css } from '@emotion/css';

export const FormContainer = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-ml);
`;

export const TitleBlock = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
`;

export const Heading = css`
  margin: 0;
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
`;

export const Subtitle = css`
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
`;

export const TermsContainer = css`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Text = css`
  font-size: var(--font-size-2xs);
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-normal);
`;

export const TextButton = css`
  border: none;
  background: transparent;
  padding: 0;
  font-family: var(--font-sans);
  font-size: var(--font-size-2xs);
  color: var(--color-text-link);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: color var(--duration-fast) var(--ease-standard);

  &:hover {
    color: var(--color-primary-hover);
  }
`;
